import $axios from '@/utils/request'
/**
 * 获取保利威 token vid
 * @param {*} data 
 * @returns 
 */
export function getVideoToken(data) {
    const url = '/video/getVideoToken'
    return $axios.fGet(url, data)
}